import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteScanById } from '../Scans';

export const useDeleteScan = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteScanById,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['scans'] })
    });
};
